export default {
    advertViews: 'Просмотры объявления',
    callRequest: 'Заказ звонка',
    loadError:   'Ошибка получения данных для отчета',
    newAuto:     'Новые Авто',
    phoneViews:  'Просмотры телефона',
    services:    {
        hot: 'Отправлено в «Горячие»',
        up:  'Отправлено в «ТОП»',
        vip: 'Добавлено в «VIP»',
    },
    top: 'Топ {place}',
};
